import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const STATS = [{
  value: '+800',
  label: 'Arqueros confían en el sistema'
}, {
  value: '4.9/5',
  label: 'Valoración promedio'
}, {
  value: '+180',
  label: 'Recursos y entrenamientos'
}, {
  value: '#1',
  label: 'Sistema elegido en Argentina'
}];
export const TrustPanel = () => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="max-w-md mx-auto bg-forest-900 border border-forest-800 rounded-2xl px-6 py-6 mt-2" data-id="element-155">
      {/* Top — stars + endorsement */}
      <div className="text-center pb-5 border-b border-forest-800" data-id="element-156">
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-157">
          <div className="flex gap-0.5" data-id="element-158">
            {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-grass-400 text-grass-400" data-id="element-159" />)}
          </div>
          <span className="text-white font-bold text-sm" data-id="element-160">4.9/5</span>
        </div>
        <p className="font-bold text-white text-sm md:text-base mb-1" data-id="element-161">
          Elegido por arqueros en toda Argentina
        </p>
        <p className="text-forest-300 text-xs md:text-sm leading-relaxed" data-id="element-162">
          La metodología más completa para el arquero moderno
        </p>
      </div>

      {/* Bottom — 2x2 stats grid */}
      <div className="grid grid-cols-2 gap-y-5 gap-x-4 pt-6 text-left" data-id="element-163">
        {STATS.map(stat => <div key={stat.label} data-id="element-164">
            <p className="font-anton text-3xl md:text-4xl text-grass-400 tracking-wide leading-none mb-1" data-id="element-165">
              {stat.value}
            </p>
            <p className="text-forest-200 text-xs md:text-sm leading-tight" data-id="element-166">
              {stat.label}
            </p>
          </div>)}
      </div>
    </motion.div>;
};